import * as React from 'react';
import { TransitionProps } from '@mui/material/transitions';
import { Button, DialogActions, DialogContent, Slide } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import { Typography } from '@mui/material';

export default function DialogResetForm({
    open,
    handleClose,
    handleConfirm
}: DialogResetFormProps) {

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>
                Confirmação de Novo Lançamento
            </DialogTitle>

            <DialogContent>
                <Typography>
                    Seu lançamento foi salvo com sucesso! Deseja adicionar um novo lançamento ou fechar esta janela?
                </Typography>
            </DialogContent>

            <DialogActions>
                <Button 
                    onClick={handleClose}
                    variant="outlined"
                >
                    Fechar
                </Button>

                <Button 
                    onClick={handleConfirm}
                    variant="contained"
                >
                    Adicionar
                </Button>
            </DialogActions>
        </Dialog>
    );
}


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface DialogResetFormProps {
    open: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
}
